/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

export default {
  aboutCompany: 'عن الشركة',
  partners: 'شركاؤنا',
  partners_text: 'نتعامل مع أفضل الشركات والبنوك السعودية لتوفير أفضل حلول التمويل العقاري',
  products: 'خدماتنا',
  clients: 'عملاؤنا',
  clients_text: 'أهم تعليقات وآراء عملائنا',
  faq: 'الأسئلة الشائعة',
  footer_titles: {
    a: 'عن الشركة',
    b: 'روابط',
    c: 'تواصل'
  },
  links: {
    about: 'من نحن',
    products: 'خدماتنا',
    order: 'اطلب تمويل'
  },
  landing_subtitle: 'خيارك الأمثل في مجال الوساطة العقارية بالمملكة العربية السعودية',
  header_btn: 'احصل على تمويلك الآن',
  services: [
    {
      text: 'شراء عقار'
    },
    {
      text: 'رهن عقار'
    },
    {
      text: 'رهن مباشر'
    },
    {
      text: 'إكمال بناء'
    },
    {
      text: 'بناء ذاتي'
    },
    {
      text: 'توحيد التزامات'
    },
    {
      text: 'شراء مديونية'
    },
    {
      text: 'شراء على الخارطة'
    },
    {
      text: 'ارض وقرض'
    }
  ],
  section: {
    a: 'نقدم لك أفضل الحلول التمويلية بتسهيلات و أقساط ميسرة',
    b: 'اختر الحل الذي يناسب احتياجاتك من حلول الوساطة العقارية'
  },
  vision: 'هدفنا',
  vision_text: 'ابتكار مزيد من حلول الاستشارة العقارية لتمكين الأسر السعودية من تملك مسكن مناسب لاحتياجاتهم وتعزيز قدراتهم المادية من خلال دراسة البرامج المتاحة وتوفير الحل الأمثل لهم.',
  message: 'رؤيتنا',
  message_text: 'أن نكون الوجهة الأولى لراغبي الاستشارة العقارية في المملكة العربية السعودية . و تقديم خدمة مميزة لعملائنا في المملكة .'
}
